import * as React from 'react';
import LiveScore from "../../../containers/LiveScore";
import LiveStatisticBar from "../../../containers/LiveStatisticBar";
import PlayerNames from "../../../containers/PlayerNames";
import PlayerProfiles from "../../../containers/PlayerProfiles";
import StatsControls from "../../../containers/StatsControls";
import StatsName from "../../../containers/StatsName";
import VideoArea from "../../../containers/VideoArea";
import VideoOverlay from "../../../containers/VideoOverlay";
import StatisticsCarousel from "./StatisticsCarousel";

interface StatisticsVideoAreaProps {
    showPlayerProfiles: boolean;
}

const StatisticsVideoArea = ({ showPlayerProfiles }: StatisticsVideoAreaProps) => {
    return (
        <VideoArea>
            <StatsControls direction='vertical' />
            <VideoOverlay>
                {showPlayerProfiles && (
                    <PlayerProfiles>
                        <div className="player-profiles-livescore">
                            <LiveScore deactivateClickHandler="true"/>
                        </div>
                    </PlayerProfiles>
                )}
                <PlayerNames />
                <StatsName />
                <StatisticsCarousel />
            </ VideoOverlay>
            <LiveStatisticBar />
        </ VideoArea>
    )
}

export default StatisticsVideoArea;
